import React from 'react'
import { Route, Routes } from 'react-router-dom'

import './App.css'
import Employee from './pages/Employee'
import CheckoutScreen from './pages/Checkout'
import Menu from './pages/Menu'
import Nav from './components/Nav'
import Acknowledgement from './pages/acknowledgement'
import DroneMap from './pages/DroneMap'
import StockMenu from './pages/StockMenu'

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/stock" element={<StockMenu />} />
      <Route path="/map" element={<DroneMap/>} />
      <Route path="/checkout" element={<CheckoutScreen />} />
      <Route path="/employee" element={<Employee />} />
      <Route path="/menu" element={<Menu />} />
      <Route path="/acknowledgement" element={<Acknowledgement />} />
      <Route path="/" element={<Nav />} />
    </Routes>
  )
}

export default App
